import { render, staticRenderFns } from "./DollarSignIcon.vue?vue&type=template&id=64b5a9e1&scoped=true"
import script from "./DollarSignIcon.vue?vue&type=script&lang=js"
export * from "./DollarSignIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5a9e1",
  null
  
)

export default component.exports